import {Injectable} from '@angular/core';
import {CustomNGXLoggerService, INGXLoggerConfig as LoggerConfig, NgxLoggerLevel} from 'ngx-logger';
import {environment} from '../../environments/environment';
import {AceLogger} from './ace-logger';

@Injectable()
export class AceLoggerService {

  private static readonly DEFAULT_PRODUCTION_CONFIG: LoggerConfig = {level: NgxLoggerLevel.INFO, serverLogLevel: NgxLoggerLevel.OFF};
  private static readonly DEFAULT_DEVELOPMENT_CONFIG: LoggerConfig = {level: NgxLoggerLevel.DEBUG, serverLogLevel: NgxLoggerLevel.OFF};


  private static readonly PRODUCTION_CONFIG = {};
  private static readonly DEVELOPMENT_CONFIG = {
    // Here as an example
    'sidebar': NgxLoggerLevel.DEBUG
  };

  static getDefaultConfig(): LoggerConfig {
    return environment.production ? AceLoggerService.DEFAULT_PRODUCTION_CONFIG : AceLoggerService.DEFAULT_DEVELOPMENT_CONFIG;
  }

  private static getEnvironmentConfig(): { [key: string]: LoggerConfig | NgxLoggerLevel } {
    return environment.production ? AceLoggerService.PRODUCTION_CONFIG : AceLoggerService.DEVELOPMENT_CONFIG;
  }

  private static getRelevantConfig(configEntryName: string): {configEntityName: string, config: LoggerConfig} {
    const config = AceLoggerService.getEnvironmentConfig()[configEntryName];
    if (config !== null && config !== undefined) {
      const entryType = typeof config;
      if (entryType === 'object') {
        return {configEntityName: configEntryName, config: Object.assign({}, AceLoggerService.getDefaultConfig(), config)};
      } else if (entryType === 'number') {
        return {configEntityName: configEntryName, config: Object.assign({}, AceLoggerService.getDefaultConfig(), {level: config})};
      } else {
        throw new Error('Log config entry can be string or object. The entry is ' + entryType);
      }
    } else {
      return {configEntityName: configEntryName, config: AceLoggerService.getDefaultConfig()};
    }
  }

  constructor(private customLoggerService: CustomNGXLoggerService) {}

  public create(configEntryName: string): AceLogger {
    const relevantConfig = AceLoggerService.getRelevantConfig(configEntryName);
    return new AceLogger(this.customLoggerService.getNewInstance({config: relevantConfig.config}), relevantConfig.configEntityName);
  }
}
